import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, Typography } from 'design-component';
import { IconEllipsis } from 'assets/icon';
import { palette } from 'styles/color';
import TooltipMenu from 'components/TooltipMenu';
import { formatUtcToLocal } from 'utils/format';

type Column = {
  key: string;
  title: string;
};

type RowData = {
  [key: string]: React.ReactNode;
};

type TableProps = {
  columns: Column[];
  data: RowData[];
  children?: React.ReactNode;
  setSelectedRow?: (index: number) => void;
};

const Table: React.FC<TableProps> = ({ columns, data, children, setSelectedRow }) => {
  const [menuOpenRow, setMenuOpenRow] = useState<number | null>(null);

  const handleMenuClick = (index: number) => {
    setMenuOpenRow(menuOpenRow === index ? null : index);
    if (setSelectedRow) {
      setSelectedRow(index);
    }
  };

  // const handleRename = (rowIndex: number) => {
  //   alert(`Rename row ${rowIndex}`);
  //   setMenuOpenRow(null);
  // };

  // const handleDelete = (rowIndex: number) => {
  //   alert(`Delete row ${rowIndex}`);
  //   setMenuOpenRow(null);
  // };

  const lastColumnIndex = columns.length - 1;

  // const formatCellValue = (value: any) => {
  //   const strValue = value?.toString() ?? '';
  //   return strValue.length > 20 ? `${strValue.slice(0, 12)}... ${strValue.slice(-4)}` : strValue;
  // };

  return (
    <TableWrapper>
      <StyledTable>
        <thead>
          <tr>
            {columns.map((column, index) => (
              <Th key={column.key}>
                <Typography
                  component="span"
                  color={palette.gray[900]}
                  weight={600}
                  size="16px"
                  height="18px">
                  {index === lastColumnIndex ? '' : column.title}
                </Typography>
              </Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((column, colIndex) => (
                <Td key={column.key} isLastChild={colIndex === lastColumnIndex}>
                  {colIndex === lastColumnIndex ? (
                    <>
                      <TooltipMenu
                        opener={
                          <IconButton variant="text" onClick={() => handleMenuClick(rowIndex)}>
                            <IconEllipsis />
                          </IconButton>
                        }>
                        {children}
                      </TooltipMenu>
                    </>
                  ) : (
                    <Typography
                      component="span"
                      color={palette.gray[800]}
                      weight={400}
                      size="14px"
                      height="150%">
                      {column.key === 'created_time'
                        ? formatUtcToLocal(String(row[column.key] || ''), 'yyyy-MM-dd HH:mm')
                        : row[column.key]}
                    </Typography>
                  )}
                </Td>
              ))}
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </TableWrapper>
  );
};

export default Table;

export const TableWrapper = styled.div`
  width: 100%;
  border: 1px solid ${palette.gray[200]};
  border-radius: 8px;
  overflow: visible;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Th = styled.th`
  padding: 13px 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dadce0;
  text-align: left;
`;

export const Td = styled.td<{ isLastChild: boolean }>`
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  position: relative;
  width: 32%;
  height: 44px;
  vertical-align: middle;
  padding: 0 20px;

  ${({ isLastChild }) =>
    isLastChild &&
    `
    flex: 1;
    // padding: 10px 9px;
  `}
`;

export const IconButton = styled(Button)`
  background: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 2px 4px;
  font-size: 16px;

  &:hover {
    background-color: #f5f5f5;
  }
`;
